import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Role } from '../models/role.model';

@Injectable({
  providedIn: 'root'
})
export class RolesService {
  private readonly roleBaseUrl: string;

  constructor(private readonly httpClient: HttpClient,
    private readonly  baseUrl: string)
    {
      this.roleBaseUrl = `${this.baseUrl}`;
    }

    getAllRoles(): Observable<Role[]> {
      const url = this.roleBaseUrl;
      return this.httpClient.get(url).pipe(map(roles => {
        return roles['items'].map(r => { //roles must be store uppercase in user
          r.name = r.name.toUpperCase();
          return r;
        })
      })) as Observable<Role[]>;
    }

    postNewRole(name: string): Observable<Role> {
      return this.httpClient.post(this.roleBaseUrl, {name: name} ) as Observable<Role>;
    }

    deleteRole(name: string): Observable<any> {
      return this.httpClient.delete(this.roleBaseUrl + name);
    }

  }
